// @flow

import {
    CONTENT_TYPE_OCTET_STREAM,
    CONTENT_TYPE_SVG,
    CONTENT_TYPE_PNG,
    CONTENT_TYPE_XLS,
    CONTENT_TYPE_PDF
} from '../constants';

export const isJson = (response: Response): boolean => {
    const contentType = response.headers.get('Content-Type');

    if (!contentType) {
        return false;
    }
    return contentType.includes('application/json');
};

const mimeTypes = [
    CONTENT_TYPE_OCTET_STREAM,
    CONTENT_TYPE_SVG,
    CONTENT_TYPE_PNG,
    CONTENT_TYPE_XLS,
    CONTENT_TYPE_PDF
];

export const isBlob = (response: Response): boolean => {
    const contentType = response.headers.get('Content-Type') || '';

    return mimeTypes.some(mimeType => (
        contentType.toLowerCase().includes(mimeType.toLowerCase())
    ));
};

export const responseToPromise = (response: Response): Promise<Object | string> => {
    if (isBlob(response)) {
        return response.blob();
    }

    return isJson(response) ? response.json() : response.text();
};
